/* winterburn: concept A behaviours (leader lines, discography filter) */
(function () {
  function drawLeads() {
    document.querySelectorAll('.A .stage').forEach(function (stage) {
      var svg = stage.querySelector('.leads'), cover = stage.querySelector('.cover');
      if (!svg || !cover) return;
      if (window.matchMedia('(max-width: 989px)').matches) { svg.innerHTML = ''; return; }
      var st = stage.getBoundingClientRect(), cv = cover.getBoundingClientRect(), out = '';
      stage.querySelectorAll('.tag[data-lead]').forEach(function (t) {
        var r = t.getBoundingClientRect(), side = t.dataset.lead;
        var left = side.charAt(1) === 'l';
        var tx = left ? r.right + 14 : r.left - 14, ty = r.top + 10;
        var cx = left ? cv.left : cv.right, cy = side.charAt(0) === 't' ? cv.top + cv.height * 0.28 : cv.top + cv.height * 0.72;
        var mx = left ? cx - 40 : cx + 40;
        out += '<line x1="' + (tx - st.left) + '" y1="' + (ty - st.top) + '" x2="' + (mx - st.left) + '" y2="' + (ty - st.top) + '"/>' +
               '<line x1="' + (mx - st.left) + '" y1="' + (ty - st.top) + '" x2="' + (cx - st.left) + '" y2="' + (cy - st.top) + '"/>' +
               '<circle cx="' + (cx - st.left) + '" cy="' + (cy - st.top) + '" r="2.5"/>';
      });
      svg.innerHTML = out;
    });
  }
  function initFilters() {
    document.querySelectorAll('.A .flt').forEach(function (flt) {
      var wrap = flt.parentElement, disc = wrap.querySelector('[data-disc]'), count = wrap.querySelector('[data-disc-count]');
      if (!disc) return;
      flt.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-f]'); if (!b) return;
        flt.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var f = b.dataset.f, n = 0;
        disc.querySelectorAll('.rc').forEach(function (c) {
          var on = f === 'all' || c.dataset.type === f;
          c.hidden = !on; if (on) n++;
        });
        disc.querySelectorAll('[data-yr]').forEach(function (y) { y.hidden = !y.querySelector('.rc:not([hidden])'); });
        if (count) count.textContent = n + ' releases';
      });
    });
  }
  function init() { drawLeads(); initFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', drawLeads);
  window.addEventListener('resize', drawLeads);
  document.addEventListener('shopify:section:load', init);
})();

/* header: solid once the page scrolls */
(function () {
  var b = document.body, on = false;
  function upd() { var s = window.scrollY > 40; if (s !== on) { on = s; b.classList.toggle('wb-scrolled', s); } }
  window.addEventListener('scroll', upd, { passive: true }); upd();
})();

/* pre-save countdown */
(function () {
  if (customElements.get('wb-countdown')) return;
  customElements.define('wb-countdown', class extends HTMLElement {
    connectedCallback() {
      var at = this.dataset.at || '';
      var m = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(at);
      if (!m) { this.hidden = true; return; }
      this.target = new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)).getTime();
      this.u = {}; var self = this;
      this.querySelectorAll('[data-u]').forEach(function (el) { self.u[el.dataset.u] = el; });
      this.tick(); this.t = setInterval(this.tick.bind(this), 1000);
    }
    disconnectedCallback() { clearInterval(this.t); }
    tick() {
      var left = Math.max(0, this.target - Date.now());
      if (!left) {
        clearInterval(this.t); this.classList.add('is-out');
        var l = this.querySelector('.cdn-l'); if (l && this.dataset.out) l.textContent = this.dataset.out;
        return;
      }
      var s = Math.floor(left / 1000), p = function (n) { return (n < 10 ? '0' : '') + n; };
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      for (var k in v) if (this.u[k]) this.u[k].textContent = p(v[k]);
    }
  });
})();

/* newsletter popup
   Opened with show() (not showModal) so the rest of the page is not made inert:
   Shopify's spam check (hCaptcha) runs outside the popup and must stay usable. */
(function () {
  var KEY = 'wb-popup';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function init() {
    var d = document.getElementById('wbPopup'); if (!d || !d.show) return;
    if (window.Shopify && window.Shopify.designMode) return;
    var bd = d.parentNode.querySelector('.pop-bd'), last = null;
    var st = get(), days = +d.dataset.days || 30, delay = (+d.dataset.delay || 10) * 1000;
    if (document.querySelector('.nlb-msg[role="status"]')) { st.joined = 1; set(st); }
    function open() {
      if (d.open) return;
      last = document.activeElement;
      if (bd) bd.hidden = false;
      d.show();
      var box = d.querySelector('.pop-box'); if (box) box.focus({ preventScroll: true });
    }
    function close() {
      if (!d.open || d.classList.contains('is-closing')) return;
      d.classList.add('is-closing'); if (bd) bd.classList.add('is-closing');
      setTimeout(function () {
        d.classList.remove('is-closing'); d.close();
        if (bd) { bd.classList.remove('is-closing'); bd.hidden = true; }
        if (!get().joined) set({ until: Date.now() + days * 864e5 });
        if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (e) {}
      }, 260);
    }
    d.wbClose = close;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) close(); });
    d.addEventListener('click', function (e) { if (e.target.closest('[data-pop-close]')) close(); });
    if (bd) bd.addEventListener('click', close);
    var f = d.querySelector('form'); if (f) f.addEventListener('submit', function () { var s = get(); s.joined = 1; set(s); });
    if (d.querySelector('.nlb-msg')) { open(); return; }
    if (st.joined || (st.until && Date.now() < st.until)) return;
    setTimeout(function () { if (!document.querySelector('dialog[open]')) open(); }, delay);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Spotify players: load once the page itself has loaded, and only when the player is near the screen */
(function () {
  function arm() {
    var els = document.querySelectorAll('iframe[data-wb-src]'); if (!els.length) return;
    var go = function (f) { if (f.dataset.wbSrc) { f.src = f.dataset.wbSrc; f.removeAttribute('data-wb-src'); } };
    if (!('IntersectionObserver' in window)) { els.forEach(go); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { go(e.target); io.unobserve(e.target); } }); }, { rootMargin: '300px 0px' });
    els.forEach(function (f) { io.observe(f); });
  }
  if (document.readyState === 'complete') setTimeout(arm, 300); else window.addEventListener('load', function () { setTimeout(arm, 300); });
  document.addEventListener('shopify:section:load', arm);
})();

/* 30s previews (Apple Music): one shared player for the main button and every track row */
(function () {
  var au = null, cur = null;
  var PLAY = '<svg viewBox="0 0 16 16"><path d="M4 2.5v11l9.5-5.5z"/></svg>', PAUSE = '<svg viewBox="0 0 16 16"><path d="M4 2.5h3v11H4zM9 2.5h3v11H9z"/></svg>';
  function btns(src) { return document.querySelectorAll('[data-pv-src="' + src.replace(/"/g, '\\"') + '"]'); }
  function paint() {
    document.querySelectorAll('[data-pv-src]').forEach(function (b) {
      var on = !!(au && cur && b.dataset.pvSrc === cur && !au.paused);
      b.classList.toggle('is-playing', on); b.closest('.trow') && b.closest('.trow').classList.toggle('is-playing', on);
      var ic = b.querySelector('.pv-ic, .tpl-ic'); if (ic) ic.innerHTML = on ? PAUSE : PLAY;
      var l = b.querySelector('[data-pv-lbl]'); if (l) l.textContent = on ? 'Now playing' : (au && cur === b.dataset.pvSrc && au.currentTime > 0 && !au.ended ? 'Paused' : 'Play preview');
    });
  }
  function progress() {
    if (!au || !cur || !au.duration) return;
    var f = au.currentTime / au.duration, left = Math.max(0, Math.ceil(au.duration - au.currentTime));
    btns(cur).forEach(function (b) {
      var pr = b.querySelector('.pv-pr'); if (pr) pr.style.strokeDashoffset = 176 * (1 - f);
      var sub = b.querySelector('[data-pv-sub]'); if (sub) sub.textContent = b.dataset.pvTitle + ' · 0:' + (left < 10 ? '0' : '') + left;
      var row = b.closest('.trow'); var bar = row && row.querySelector('.len-pr'); if (bar) bar.style.width = (f * 100) + '%';
    });
  }
  function reset(src) {
    btns(src).forEach(function (b) {
      var pr = b.querySelector('.pv-pr'); if (pr) pr.style.strokeDashoffset = 176;
      var sub = b.querySelector('[data-pv-sub]'); if (sub) sub.textContent = b.dataset.pvTitle + ' · 0:30';
      var row = b.closest('.trow'); var bar = row && row.querySelector('.len-pr'); if (bar) bar.style.width = 0;
    });
  }
  function init() {
    document.querySelectorAll('.pv-ic, .tpl-ic').forEach(function (ic) { if (!ic.innerHTML) ic.innerHTML = PLAY; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pv-src]'); if (!b) return;
    e.preventDefault();
    var src = b.dataset.pvSrc;
    if (!au) {
      au = new Audio(); au.preload = 'auto';
      au.addEventListener('play', paint); au.addEventListener('pause', paint);
      au.addEventListener('timeupdate', progress);
      au.addEventListener('ended', function () { var s = cur; paint(); reset(s); au.currentTime = 0; });
      au.addEventListener('error', function () { paint(); });
    }
    if (cur === src) { if (au.paused) au.play().catch(paint); else au.pause(); return; }
    if (cur) { au.pause(); reset(cur); }
    cur = src; au.src = src; au.play().catch(paint); paint();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Music cover wall: fade in once the first set of covers has loaded */
(function(){var w=document.querySelector('[data-phd-wall]');if(!w)return;var im=[].slice.call(w.querySelectorAll('img'),0,25),n=im.length,d=0,done=false;
function on(){if(done)return;done=true;w.classList.add('on')}
if(!n)return on();im.forEach(function(i){if(i.complete)d++;else{i.addEventListener('load',k);i.addEventListener('error',k)}});function k(){if(++d>=n)on()}if(d>=n)on();setTimeout(on,2500)})();
